declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

const PIXEL_ID = '2071338433724589'

export function initMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  window.fbq('init', PIXEL_ID)
  window.fbq('set', 'autoConfig', 'true', PIXEL_ID)
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
    console.log('✅ Meta Pixel: PageView fired')
  } else {
    console.warn('⚠️ Meta Pixel: fbq not loaded yet for PageView')
  }
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Método Anti-Tipster',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
    console.log('✅ Meta Pixel: AddToCart fired')
  } else {
    console.warn('⚠️ Meta Pixel: fbq not loaded yet for AddToCart')
  }
}
